import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import PATHS from '@/common/paths';
import { CardReplaceReason } from '@/modules/transaction/components/Cards/Cards.types';

export enum ReplacementInitiationType {
  BANNER = 'BANNER',
  CARDS_PAGE = 'CARDS_PAGE',
  ADMIN_PORTAL = 'ADMIN_PORTAL',
}

interface ReplacementCardData {
  reason: CardReplaceReason | string;
  replacement_initiation_type?: ReplacementInitiationType;
  // address_line1: string,
  // address_line2: string,
  // city: string,
  // state: string,
  // zip: string,
}

interface ReplacementRequestCardData {
  cardID: string;
  data: ReplacementCardData;
  replacementInitiationType?: ReplacementInitiationType;
}

export default () => {
  const { mutateAsync, isLoading, status } = useMutation((args: ReplacementRequestCardData) =>
    api.post(PATHS.REPLACEMENT_CARD_REQUEST(args.cardID), {
      ...args.data,
      replacement_initiation_type: args?.replacementInitiationType,
    })
  );

  const handleSave = async (data: ReplacementRequestCardData) => {
    await mutateAsync(data);
  };

  return {
    onSave: handleSave,
    isLoading,
    status,
  };
};
